import Vue from "vue";
import Router from "vue-router";
import Login from "@/components/participant/Login";
import store from "@/store";
import Home from "@/components/participant/Home";
import { IS_AUTHENTICATED } from "@/store/getters";
import {
  AUTH_INIT,
  CLEAR_AGENDA_FILTER,
  LOAD_EVENT_TYPE,
  LOAD_EVENT_TYPE_GROUP,
} from "@/store/types";

const ParticipantCalendar = () =>
  import(
    /* webpackChunkName: "calendar" */ "@/components/participant/calendar/CalendarLoader"
  );
const SupervisionBoard = () =>
  import(
    /* webpackChunkName: "supervision" */ "@/components/supervision/SupervisionBoard"
  );
const NotificationList = () =>
  import(
    /* webpackChunkName: "notification" */ "@/components/participant/notification/NotificationList"
  );
const Redirect = () =>
  import(/* webpackChunkName: "redirect" */ "@/components/Redirect");

const Sso = () => import(/* webpackChunkName: "sso" */ "@/components/Sso");

import { EventBus } from "@/tools/event-bus.js";
import {
  LOAD_HOLIDAYS,
  SET_IMPERSONATE,
  SET_IMPERSONATION_REDIRECT_PATH,
} from "@/store/types";

Vue.use(Router);

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters[IS_AUTHENTICATED]) {
    next();
    return;
  }

  next("/");
};

const ifAuthenticated = (to, from, next) => {
  if (store.getters[IS_AUTHENTICATED]) {
    next();
    return;
  }
  next("/login");
};

const kronosRouter = new Router({
  mode: "history",
  base: "",
  routes: [
    {
      component: Home,
      path: "/",
      beforeEnter: ifAuthenticated,
      children: [
        {
          path: "/",
          name: "redirect-home",
          component: Redirect,
        },
        {
          path: "calendar",
          name: "calendar",
          component: ParticipantCalendar,
        },
        {
          path: "calendar/:year/:week",
          name: "calendar-week",
          component: ParticipantCalendar,
        },
        {
          path: "auditor-calendar/:id/:year/:week",
          name: "auditor-calendar",
          component: ParticipantCalendar,
        },

        {
          path: "notification",
          name: "notification",
          component: NotificationList,
        },
        {
          path: "supervision",
          name: "supervision",
          component: SupervisionBoard,
        },
      ],
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      beforeEnter: ifNotAuthenticated,
    },
    {
      path: "/sso",
      name: "sso",
      component: Sso,
      beforeEnter: ifNotAuthenticated,
    },
    {
      path: "/impersonate/:id/:year/:week",
      name: "impersonate-week",
      redirect: (to) => {
        store.dispatch(SET_IMPERSONATION_REDIRECT_PATH, to.query?.redirect);
        store.dispatch(SET_IMPERSONATE, to.params.id);

        return `calendar/${to.params.year}/${to.params.week}`;
      },
    },
    {
      path: "/impersonate/:id",
      name: "impersonate",
      redirect: (to) => {
        store.dispatch(SET_IMPERSONATE, to.params.id);

        return "calendar";
      },
    },
    {
      path: "*",
      name: "redirect",
      component: Redirect,
    },
  ],
});

store.watch(
  (_state, getters) => getters.GET_CALENDAR_ISO_WEEK,
  (week) => {
    store.dispatch(LOAD_HOLIDAYS, week);
  }
);

kronosRouter.beforeResolve(async (to, from, next) => {
  // If this isn't an initial page load.
  if (["login", "sso"].includes(to.name)) {
    next();
    return;
  }

  EventBus.$emit("start-loading");
  await store.dispatch(AUTH_INIT);

  await Promise.all([
    store.dispatch(LOAD_EVENT_TYPE),
    store.dispatch(LOAD_EVENT_TYPE_GROUP),
    store.dispatch(CLEAR_AGENDA_FILTER),
    store.dispatch(LOAD_HOLIDAYS, store.getters.GET_CALENDAR_ISO_WEEK),
  ]);

  next();
});

kronosRouter.afterEach(() => {
  EventBus.$emit("stop-loading");
});

export default kronosRouter;
